import { defineMessages } from 'react-intl';

const messages = defineMessages({
  restoreButton: {
    defaultMessage: 'Restore',
    id: 'KsCqDY',
    description: 'label for a button that allows the user to restore a shipment',
  },
  restoreCancelledHeaderTitle: {
    defaultMessage: 'This shipment is imported as Cancelled',
    id: 'DaDW11',
    description: 'title for the restore header which allows the user to restore a shipment',
  },
  restoreShippedHeaderTitle: {
    defaultMessage: 'This shipment is imported as Shipped',
    id: 'Ma1Y2L',
    description: 'title for the restore header which allows the user to restore a shipment',
  },
  restoreHeaderMessage: {
    defaultMessage: 'Click Restore to move this shipment into Awaiting Shipment status.',
    id: 'NH1FLg',
    description: 'message for the restore header which allows the user to restore a shipment',
  },
  restoreShipmentSuccessTitle: {
    defaultMessage: 'Restore Confirmed',
    description: 'success restoring order title',
    id: 'tKauOB',
  },
  restoreShipmentSuccessMessage: {
    defaultMessage: 'Your order has been restored.',
    description: 'success restoring order content',
    id: 'rktE3Y',
  },
  restoreShipmentErrorTitle: {
    defaultMessage: 'Restore Error',
    description: 'error restoring order title',
    id: 'SePlK9',
  },
  restoreShipmentErrorMessage: {
    defaultMessage: 'There was an error restoring your order. Please try again.',
    description: 'error restoring order content',
    id: 'LNvFbA',
  },
  restoreShipment: {
    defaultMessage: 'Restore Shipment',
    id: 'uj2w4V',
    description: 'label for a button that allows the user to restore a shipment',
  },
});

export default messages;
